import React, { useContext } from "react";
import classNames from "classnames";
import styles from "src/components/Pages/DocumentInbound/DocumentComplianceHelper/styles.module.scss";
import { useTranslation } from "react-i18next";
import Markdown from "markdown-to-jsx";
import { type ComplianceHelperField } from "./document-compliance-helper-extractor";
import ValidationUserActions from "src/components/UserActions/ValidationUserActions";
import { useDocumentCompliance } from "src/components/Contexts/DocumentComplianceContext";
import { ModalWrapperContext } from "src/components/Modal/ModalWrapperContext";
import { ValidationRuleSeverity } from "src/api/interfaces/document_validation";
import { KatSpinner } from "@amzn/katal-react";
import { ValidationUserActionType } from "src/components/UserActions/types";
import { MetricAction } from "src/metrics";

interface ComplianceErrorSolutionProps {
  selectedItem: ComplianceHelperField | null;
}

const ComplianceErrorSolution: React.FC<ComplianceErrorSolutionProps> = ({
  selectedItem,
}) => {
  const { t } = useTranslation();
  const { validationGroups, userActionsByValidationGroup } =
    useDocumentCompliance();
  const { setVisible } = useContext(ModalWrapperContext);

  const validationGroup = validationGroups.find(
    (group) => group.validationGroupId === selectedItem?.validationGroupId
  );

  const shouldShowValidationActions =
    validationGroup &&
    selectedItem &&
    (selectedItem.severity === ValidationRuleSeverity.ERROR.valueOf() ||
      selectedItem.severity === ValidationRuleSeverity.CRITICAL.valueOf() ||
      selectedItem.severity === ValidationRuleSeverity.SEVERE.valueOf()) &&
    userActionsByValidationGroup?.[selectedItem.validationGroupId]?.filter(
      ({ type }) => type !== ValidationUserActionType.VIEW
    )?.[0];

  return (
    <>
      {validationGroup ? (
        <div className={classNames(styles.resolution_guide)}>
          <div className={classNames(styles.resolution_guide_header)}>
            <h4>
              {t("aic_doc_page_inbound_document_compliance_helper_details")}
            </h4>
            <div
              onClick={() => {
                setVisible(true);
              }}
            >
              {shouldShowValidationActions && (
                <ValidationUserActions
                  key={validationGroup.validationGroupId}
                  content={validationGroup}
                  metricAction={
                    MetricAction.COMPLIANCE_HELPER_PANEL_USER_ACTION
                  }
                />
              )}
            </div>
          </div>
          {selectedItem && (
            <>
              <p>{t(selectedItem.comment)}</p>
              {selectedItem.sopDetails && (
                <Markdown>{selectedItem.sopDetails}</Markdown>
              )}
            </>
          )}
        </div>
      ) : (
        <KatSpinner size={"small"} />
      )}
    </>
  );
};

export default ComplianceErrorSolution;
